import styled from 'styled-components'
import { Input, Select } from 'antd'
import { desktop } from '../../globalAssets/fontsize'
import { device } from '../../globalAssets/breakpoints'
export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  padding: 1vw;
  & > div {
  }
`

export const StyledInput = styled(Input.TextArea)`
  &&& {
    width: '100%';
    ${'' /* height: 15px; */}
    ${'' /* cursor: pointer; */}
    /* transition: ease-in all 0.3s; */
    padding-left: 10px;
    outline: none;
    font-size: 14px;
    overflow-y: auto;
    /* background: none; */
    border: 1px solid ${(props) => props.theme.subtleBlack};
    background: ${(props) => props.theme.foreground};

    color: ${(props) => props.theme.color};

    .ant-input {
      background: ${(props) => props.theme.background};
      color: ${(props) => props.theme.color};
      font-size: ${desktop.normal};
    }
    :active,
    :focus,
    :hover {
      border: 1px solid ${(props) => props.theme.primaryColor};
    }
  }
`
export const Dropdown = styled(Select)`
  &&& {
    outline: none;
    border: none;
    background: ${(props) => props.theme.foreground};
    width: 100%;
    border: 1px solid ${(props) => props.theme.subtleBlack};

    /* background-color: re; */
    /* padding: 5px 10px; */
    font-size: 14px !important;
    color: ${(props) => props.theme.color};
    /* height: 100%; */
    /* height: 2.5vw; */
    cursor: pointer;
    &:focus,
    &:active {
      font-size: ${desktop.small};
      outline: none;
      border: none;
    }
    .ant-select-selector,
    .ant-select {
      background: ${(props) => props.theme.foreground} !important;
      border: none;
      width: 100%;
      box-shadow: none;
      outline: none;
      :active,
      :hover,
      :focus {
        border: none !important;
        outline: none;
      }
      span {
        background: ${(props) => props.theme.background} !important;
        color: ${(props) => props.theme.color};
      }
    }
    @media ${device.laptop} {
      font-size: ${desktop.small} !important;
    }
  }
`

export const AddImageDiv = styled.div`
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: flex;
  height: 100px;
  width: 100px;
  background: ${(props) => props.theme.tableLowLight};
  border-radius: 5px;
  border: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  margin-right: 10px;
  h3 {
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: center;
    font-size: 50px;
    color: white;
  }
  @media ${device.laptop} {
    height: 7vw;
    width: 7vw;

    margin-right: 10px;

    h3 {
      font-size: 5vw;
    }
  }
`
export const StyledName = styled.h3`
  color: ${(props) => props.theme.primaryColor};
  font-style: italic;
  font-weight: 400;
  font-size: 14px;

  @media ${device.laptop} {
    font-size: ${desktop.small};
  }
`
export const Error = styled.h3`
  font-style: italic;
  font-size: ${desktop.small};
  font-weight: 400;
  color: red;
`
export const DisplayImage = styled.img`
  cursor: pointer;
  border-radius: 5px;
  border: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  height: 100px;
  width: 100px;
  margin-right: 10px;
  @media ${device.laptop} {
    height: 7vw;
    width: 7vw;
  }
`
export const ClearImageList = styled.button`
  background: red;
  color: white;
  padding: 0.2vw;
  margin: 1vw 0;
  border: none;
  cursor: pointer;
  outline: none;
`
